import { defineMessages } from 'react-intl';

import type { RegenerativeMedicineLifecycleState } from './types';

export const regenerativeMedicineOpsMessages = defineMessages({
  pageTitle: {
    id: 'RegenerativeMedicineOps.pageTitle',
    defaultMessage: 'Regenerative Medicine Operations',
  },
  pipelineSummary: {
    id: 'RegenerativeMedicineOps.pipelineSummary',
    defaultMessage: '{count, plural, one {# member} other {# members}} in view',
  },
  columnName: {
    id: 'RegenerativeMedicineOps.columnName',
    defaultMessage: 'Member',
  },
  columnLifecycle: {
    id: 'RegenerativeMedicineOps.columnLifecycle',
    defaultMessage: 'Lifecycle state',
  },
  columnProvenance: {
    id: 'RegenerativeMedicineOps.columnProvenance',
    defaultMessage: 'Source freshness',
  },
  viewDetails: {
    id: 'RegenerativeMedicineOps.viewDetails',
    defaultMessage: 'View details',
  },
  openMemberDashboard: {
    id: 'RegenerativeMedicineOps.openMemberDashboard',
    defaultMessage: 'Open member dashboard',
  },
  loadError: {
    id: 'RegenerativeMedicineOps.loadError',
    defaultMessage: 'Unable to load regenerative medicine operations data.',
  },
  emptyPipeline: {
    id: 'RegenerativeMedicineOps.emptyPipeline',
    defaultMessage: 'No members match the current filters.',
  },
  evidenceTitle: {
    id: 'RegenerativeMedicineOps.evidenceTitle',
    defaultMessage: 'Synced evidence',
  },
  provenanceTitle: {
    id: 'RegenerativeMedicineOps.provenanceTitle',
    defaultMessage: 'Lifecycle provenance',
  },
  memberDetailUnavailable: {
    id: 'RegenerativeMedicineOps.memberDetailUnavailable',
    defaultMessage:
      'Unable to load regenerative medicine operations detail for this member.',
  },
  emptyEvidence: {
    id: 'RegenerativeMedicineOps.emptyEvidence',
    defaultMessage: 'No synced evidence events for this member yet.',
  },
  loadMore: {
    id: 'RegenerativeMedicineOps.loadMore',
    defaultMessage: 'Load more',
  },
});

export const provenanceStatusMessages = {
  synced: {
    id: 'RegenerativeMedicineOps.provenanceStatus.synced',
    defaultMessage: 'Synced',
  },
  missing: {
    id: 'RegenerativeMedicineOps.provenanceStatus.missing',
    defaultMessage: 'Missing',
  },
  not_available: {
    id: 'RegenerativeMedicineOps.provenanceStatus.not_available',
    defaultMessage: 'Not available',
  },
} as const;

export const lifecycleStateMessages: Record<
  RegenerativeMedicineLifecycleState,
  { id: string; defaultMessage: string }
> = {
  interest_flagged: {
    id: 'RegenerativeMedicineOps.lifecycle.interestFlagged',
    defaultMessage: 'Interest flagged (source not connected)',
  },
  consult_scheduled: {
    id: 'RegenerativeMedicineOps.lifecycle.consultScheduled',
    defaultMessage: 'Consult scheduled',
  },
  consult_completed: {
    id: 'RegenerativeMedicineOps.lifecycle.consultCompleted',
    defaultMessage: 'Consult completed',
  },
  consent_complete: {
    id: 'RegenerativeMedicineOps.lifecycle.consentComplete',
    defaultMessage: 'Consent complete',
  },
  procedure_documented: {
    id: 'RegenerativeMedicineOps.lifecycle.procedureDocumented',
    defaultMessage: 'Procedure documented (source not connected)',
  },
  revenue_captured: {
    id: 'RegenerativeMedicineOps.lifecycle.revenueCaptured',
    defaultMessage: 'Revenue captured (source not connected)',
  },
  post_procedure_followups: {
    id: 'RegenerativeMedicineOps.lifecycle.postProcedureFollowups',
    defaultMessage: 'Post-procedure follow-ups',
  },
  not_assessed: {
    id: 'RegenerativeMedicineOps.lifecycle.notAssessed',
    defaultMessage: 'Not assessed from synced sources',
  },
};
